import React, { useEffect } from 'react';
import { Container, Title, Text, List } from '@mantine/core';
import classes from './Terms.module.css';

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.wrapper}>
      <Container size="md" className={classes.inner}>
        <Title order={1} className={classes.title}>Terms of Use</Title>
        
        <section className={classes.section}>
          <Title order={2}>1. Agreement to Terms</Title>
          <Text>
            By accessing and using Optifyne's services, you agree to be bound by these Terms of Use
            and all applicable laws and regulations.
          </Text>
        </section>

        <section className={classes.section}>
          <Title order={2}>2. Use License</Title>
          <Text>
            Permission is granted to temporarily access the materials on Optifyne's website. This is the
            grant of a license, not a transfer of title.
          </Text>
          <List mt="md">
            <List.Item>You must not modify or copy these materials</List.Item>
            <List.Item>You must not use the materials for any commercial purpose</List.Item>
            <List.Item>You must not attempt to reverse engineer any software contained on the website</List.Item>
          </List>
        </section>

        <section className={classes.section}>
          <Title order={2}>3. Disclaimer</Title>
          <Text>
            The materials on Optifyne's website are provided on an 'as is' basis. Optifyne makes no
            warranties, expressed or implied, and hereby disclaims and negates all other warranties
            including, without limitation, implied warranties or conditions of merchantability, fitness
            for a particular purpose, or non-infringement of intellectual property or other violation
            of rights.
          </Text>
        </section>

        <section className={classes.section}>
          <Title order={2}>4. Limitations</Title>
          <Text>
            In no event shall Optifyne or its suppliers be liable for any damages (including, without
            limitation, damages for loss of data or profit, or due to business interruption) arising
            out of the use or inability to use the materials on Optifyne's website.
          </Text>
        </section>

        <section className={classes.section}>
          <Title order={2}>5. Revisions</Title>
          <Text>
            The materials appearing on Optifyne's website could include technical, typographical, or
            photographic errors. Optifyne does not warrant that any of the materials on its website
            are accurate, complete, or current. Optifyne may make changes to the materials contained
            on its website at any time without notice.
          </Text>
        </section>
      </Container>
    </div>
  );
}
